// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Badge';



// WEBPACK FOOTER //
// ./components/Badge/index.js